import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';
import CategoryNav from './components/CategoryNav';
import Reviews from './components/Reviews';
import CTASection from './components/CTASection';
import SEOHead from '@/components/feature/SEOHead';

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "土豪漫画网 - 蜜桃少年漫画",
    "url": "http://i2p1d.com/",
    "description": "通过土豪漫画网漫画全集下拉式免费阅读蜜桃少年，随时下拉浏览全集中文内容，体验免费且便捷的在线漫画阅读服务。",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "http://i2p1d.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "土豪漫画网",
    "url": "http://i2p1d.com/",
    "description": "国内领先的在线漫画阅读平台，提供漫画全集下拉式免费阅读服务",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "400-888-6666",
      "contactType": "customer service",
      "email": "hello@i2p1d.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "http://i2p1d.com/"
      }
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "蜜桃少年漫画-漫画全集下拉式免费阅读-土豪漫画网",
    "description": "蜜桃少年漫画,漫画全集下拉式免费阅读,土豪漫画网。通过土豪漫画网漫画全集下拉式免费阅读蜜桃少年，随时下拉浏览全集中文内容，体验免费且便捷的在线漫画阅读服务。",
    "url": "http://i2p1d.com/",
    "isPartOf": { "@type": "WebSite", "name": "土豪漫画网", "url": "http://i2p1d.com/" },
    "breadcrumb": { "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "首页", "item": "http://i2p1d.com/" }] }
  };

  return (
    <>
      <SEOHead
        title="蜜桃少年漫画-漫画全集下拉式免费阅读-土豪漫画网"
        description="蜜桃少年漫画,漫画全集下拉式免费阅读,土豪漫画网。通过土豪漫画网漫画全集下拉式免费阅读蜜桃少年，随时下拉浏览全集中文内容，体验免费且便捷的在线漫画阅读服务。"
        keywords="蜜桃少年漫画,漫画全集下拉式免费阅读,土豪漫画网"
        canonicalUrl="http://i2p1d.com/"
        ogTitle="蜜桃少年漫画-漫画全集下拉式免费阅读-土豪漫画网"
        ogDescription="蜜桃少年漫画,漫画全集下拉式免费阅读,土豪漫画网。随时下拉浏览全集中文内容，体验免费且便捷的在线漫画阅读服务。"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20manga%20website%20preview%20image%20with%20warm%20peach%20colors%2C%20artistic%20anime%20style%2C%20clean%20modern%20design%2C%20no%20text%2C%20dreamy%20atmosphere&width=1200&height=630&seq=og-homepage&orientation=landscape"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <HotRecommend />
        <LatestUpdates />
        <CategoryNav />
        <Reviews />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}